<template>
  <div class="header" ref="header">
    <div class="left" ref="left">
      <div class="menuManage">
        <button @click="openMenu()">
          <img src=@/assets/img/icon/caidan.png />
        </button>
      </div>
      <!-- logo部分 -->
      <div class="logo" ref="logo">
        <router-link to="/" exact>
          <img src=@/assets/img/icon/logo.png width=30px v-show='!$store.state.user.oemInfo.afterLoginLogo ||
          $store.state.user.userInfo.vipStatus <= 0' /> <img src=@/assets/img/icon/weihudashi.png width=100px
            style="top:5px" v-show='!$store.state.user.oemInfo.afterLoginLogo ||
            $store.state.user.userInfo.vipStatus <= 0' />
          <span v-show="
            !$store.state.user.oemInfo.afterLoginLogo ||
            $store.state.user.userInfo.vipStatus == -1
          ">远程管理平台</span>
          <img height="30px" :src="$store.state.user.oemInfo.afterLoginLogo" alt="" v-show="
            $store.state.user.oemInfo.afterLoginLogo &&
            $store.state.user.userInfo.vipStatus > 0
          " />
        </router-link>
      </div>
      <!-- 搜索网吧部分 -->
      <div class="search">
        <!-- <search-bar-input @change="searchChange" :placeholder="`搜索网吧名/网吧ID`" @blur="searchBlur" @search="searchBar">
        </search-bar-input> -->
        <!-- <transition appear appear-class="animated fadeInDown"> -->
        <input type="text" v-model="searchInfo" style="height:32px; margin-top: 15px; text-indent: 4px;"
          onfocus="this.removeAttribute('readonly');" readonly class="fl" autocomplete="off">
        <Button slot="append" icon="ios-search" style="margin-left:-2px;" @click="searchBar(searchInfo)"></Button>
        <div class="search-drop" v-show="searchList.length > 0">
          <ul>
            <li class="search-item" v-for="(item, index) in searchList" :key="index" @click="jump(item)">
              <div class="icon">
                <!-- 在线的icon -->
                <img src=@/assets/img/icon/u1425.png v-show="item.bsOnlineCnt > 0" />
                <!-- 离线的icon -->
                <img src=@/assets/img/icon/u1429.png v-show="item.bsOnlineCnt == 0" />
              </div>
              <div>
                <p v-text="item.barName"></p>
                <p v-text="item.groupName"></p>
              </div>
              <div>
                <span v-text="item.bcOnline"></span>
                <span>/</span>
                <span v-text="item.bcSum"></span>
              </div>
            </li>
          </ul>
        </div>
        <!-- </transition> -->
      </div>
    </div>
    <div class="right" ref="right">
      <!-- 栏目部分 -->
      <header-menu class="menu-list"></header-menu>
    </div>
  </div>
</template>

<script>
// 搜索框组件
import SearchBarInput from "_c/search/searchInputGray";
// 菜单组件
import HeaderMenu from "./menu";
import { getBarList } from "@/requests/bar";
import { mapState } from "vuex";
export default {
  name: "home",
  components: {
    SearchBarInput,
    HeaderMenu
  },
  data () {
    return {
      searchList: [],
      state: 0,
      searchInfo: ''
    };
  },
  computed: {
    ...mapState({
      passportType: state => state.user.userInfo.passportType,
      personalName: state => state.user.userInfo.personalName,
      judgeVip: state => state.user.userInfo.judgeVip,
      expireDate: state => state.user.userInfo.expireDate
    })
  },
  mounted () {
    // this.$domFn.addAnimateClass(this.$refs.header, 'animated fadeInDownBig')
    // this.$domFn.addAnimateClass(this.$refs.left, 'animated fadeInLeftBig')
    // this.$domFn.addAnimateClass(this.$refs.right, 'animated fadeInRightBig')
  },
  methods: {
    openMenu () {
      this.$emit("openMenus", this.state);
    },
    jump (item) {
      this.$router.push({
        path:
          this.$PAGE_API.home.children.barManager.children.index
            .children.barDetails.path +
          "/" +
          item.barId
      });
    },
    /* eslint-disable */
    searchBar (search) {
      this.$router.push({
        path:
          this.$PAGE_API.home.children.barManager.children.index
            .children.searchBar.path +
          "?search=" +
          search
      });
    },
    async searchChange (search) {
      if (search.trim() === "") return (this.searchList = []);
      let res = await getBarList({
        pageNum: 1,
        pageSize: 6,
        searchTxt: search
      });
      if (res.records.length > 0)
      {
        if (res.records.length > 6)
        {
          res.records.length = 6;
        }
        this.searchList = res.records;
      }
    },
    searchBlur () {
      setTimeout(() => {
        this.searchList = [];
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/cssfn/common.scss";
@import "_style/_color.scss";

.header {
  text-align: left;
  height: 60px;
  line-height: 60px;
  width: 100%;
  background: $black-bg;
  color: $white-word;
  position: relative;
  z-index: 99;
  @include clearfix();
}

// 左侧样式
.left {
  float: left;
  @include clearfix();
}

.menuManage {
  float: left;

  button {
    width: 60px;
    height: 60px;
    background: #00ccff;
    cursor: pointer;

    img {
      margin: 14px 0;
    }
  }
}

// 左侧log部分样式
.logo {
  float: left;

  a {
    color: #fff;
  }

  img {
    position: relative;
    top: 10px;
    margin-left: 20px;
  }

  img+img {
    top: 0;
  }

  span {
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    font-size: 14px;
  }
}

// 搜索框样式
.search {
  float: left;
  margin-left: 40px;
  position: relative;
}

.search-drop {
  position: absolute;
  top: 46px;
  left: 0;
  width: 240px;
  // height: 100px;
  background: rgba(0, 0, 0, 0.88);

  li {
    height: 70px;
    line-height: 70px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #00ccff !important;
      background-color: #252a2f;

      >div:nth-child(2) {
        p:nth-child(2) {
          color: rgba(0, 202, 251, 1) !important;
        }
      }
    }

    >div {
      float: left;
    }

    >div:nth-child(1) {
      width: 60px;
      text-align: center;
    }

    >div:nth-child(2) {
      width: 140px;
      line-height: normal;

      p:nth-child(1) {
        padding-top: 10px;
        font-size: 14px;
      }

      p:nth-child(2) {
        padding-top: 4px;
        font-size: 12px;
        color: #a3a3a3;
      }
    }

    >div:nth-child(3) {
      width: 40px;
    }
  }
}

// 右侧样式
.right {
  float: right;
}

// 菜单样式
.menu-list {
  float: left;
}

// 头像
.header-icon {
  float: left;
}
</style>
